module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/lz30/view-lz30-purchase-history/view-lz30-purchase-history.component.css
// module id = 977
// module chunks = 1